import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./Home.css";

const TEAM = [
  { name: "Sertan Turan",      role: "Öğretim Görevlisi"     },
  { name: "Hilal Nur Tınas",   role: "Bilgisayar Mühendisi"  },
  { name: "Enes Küçük",        role: "Mühendislik 4. Sınıf"  },
  { name: "Hamza Eren Yalçın", role: "Mühendislik 3. Sınıf"  },
];

const Home = () => {
  const { t } = useTranslation();

  return (
    <div className="home-container">
      <div className="video-background">
        <iframe
          src="https://www.youtube.com/embed/eJXW-GDwEEI?autoplay=1&mute=1&loop=1&playlist=eJXW-GDwEEI&controls=0&showinfo=0&rel=0&modestbranding=1&vq=hd1080&playsinline=1&iv_load_policy=3&enablejsapi=1"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Background Video"
        ></iframe>
        <div className="video-overlay"></div>
      </div>

      <div className="content-section">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="hero-content"
        >
          <h1>{t('home.title')}</h1>
          <p>{t('home.subtitle')}</p>
        </motion.div>
      </div>

      {/* Credits */}
      <motion.div
        className="home-credits"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.5 }}
      >
        {/* Üst yönetim — yanyana */}
        <div className="home-credits-leaders">
          <div className="home-credits-advisor">
            <span className="home-credits-advisor-name">Dr. Talip Emiroğlu</span>
            <span className="home-credits-advisor-label">Mütevelli Heyeti Başkanı</span>
          </div>
          <div className="home-credits-advisor">
            <span className="home-credits-advisor-name">Prof. Dr. Muzaffer Elmas</span>
            <span className="home-credits-advisor-label">Rektör</span>
          </div>
        </div>

        {/* Başlık — liderler ile ekip arasında */}
        <div className="home-credits-title">Proje Geliştirme Ekibi</div>

        {/* Ekip — yanyana */}
        <div className="home-credits-team">
          {TEAM.map((m) => (
            <div key={m.name} className="home-credits-member">
              <span className="home-credits-member-name">{m.name}</span>
              <span className="home-credits-member-role">{m.role}</span>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Home;
